const CONSENT_SESSION_KEY = "jobseeker_consent_completed";
const CONSENT_CHECK_KEY = "jobseeker_consent_check";

const readConsentFlag = (value) => {
  if (value === 0 || value === 1 || value === "0" || value === "1") {
    return String(value) === "1";
  }
  if (typeof value === "boolean") {
    return value;
  }
  return null;
};

/**
 * Parse check-consent API body.
 * Returns true when consent is already submitted (1), false when consent is 0.
 */
export const parseConsentCheckResponse = (data) => {
  const direct = readConsentFlag(data);
  if (direct !== null) return direct;

  if (!data || typeof data !== "object") {
    return true;
  }

  // Nested payload shapes: { data: { consent: 0 } } or { data: 0 }
  const nested =
    data.data && typeof data.data === "object" && !Array.isArray(data.data)
      ? data.data
      : null;

  const candidates = [
    data.consent,
    nested && nested.consent,
    data.check_consent,
    nested && nested.check_consent,
    data.has_consent,
    data.personal_info_sharing_consent,
    nested && nested.personal_info_sharing_consent,
    // raw numeric/string data field (not an object)
    readConsentFlag(data.data) !== null ? data.data : null,
    data.result,
    data.value,
  ];

  for (const candidate of candidates) {
    const parsed = readConsentFlag(candidate);
    if (parsed !== null) return parsed;
  }

  // Explicit consent key present but non-standard value — treat non-"1" as needs consent
  if (Object.prototype.hasOwnProperty.call(data, "consent")) {
    return String(data.consent) === "1";
  }
  if (nested && Object.prototype.hasOwnProperty.call(nested, "consent")) {
    return String(nested.consent) === "1";
  }

  // Unknown shape — do not block the user
  return true;
};

export const setConsentCheckResult = (hasConsent) => {
  sessionStorage.setItem(CONSENT_CHECK_KEY, hasConsent ? "1" : "0");
};

export const getConsentCheckResult = () =>
  sessionStorage.getItem(CONSENT_CHECK_KEY);

export const hasCompletedConsentThisSession = () =>
  sessionStorage.getItem(CONSENT_SESSION_KEY) === "true";

export const markConsentCompletedThisSession = () => {
  sessionStorage.setItem(CONSENT_SESSION_KEY, "true");
  setConsentCheckResult(true);
};

export const clearConsentSession = () => {
  sessionStorage.removeItem(CONSENT_SESSION_KEY);
  sessionStorage.removeItem(CONSENT_CHECK_KEY);
};

/** True when API says consent has not been submitted (0). */
export const requiresConsent = () => getConsentCheckResult() === "0";

export const shouldRedirectToConsent = () =>
  requiresConsent() && !hasCompletedConsentThisSession();

export const isConsentAllowedPath = (pathname = "") => {
  const path = String(pathname).toLowerCase();
  return (
    path.includes("consent-page") ||
    path.includes("consent-form") ||
    path.includes("/signin") ||
    path.includes("/signup") ||
    path.includes("/signout") ||
    path.includes("/logout")
  );
};

export const getConsentPagePath = (pathname = window.location.pathname) => {
  const pathParts = String(pathname || "")
    .split("/")
    .filter(Boolean);
  const lang = ["hi", "pa"].includes(pathParts[0]) ? pathParts[0] : "";
  return lang ? `/${lang}/consent-page` : "/consent-page";
};

export const isJobseekerLoggedIn = () =>
  localStorage.getItem("Islogin") === "true" &&
  localStorage.getItem("login_type") === "Jobseeker";
